import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { NavigationComponent } from './components/navigation/navigation.component';
import { MsalModule, MsalService } from '@azure/msal-angular';
import { AlertComponent } from './shared/components/alert/alert.component';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    TranslateModule,
    FormsModule,
    NavigationComponent,
    MsalModule,
    AlertComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private authService = inject(MsalService);

  title = 'Bizerba-TranslationService-Frontend';

  ngOnInit(): void {
    // Handle redirect responses - required for MSAL to work properly
    this.authService.handleRedirectObservable().subscribe();
  }
}
